import React from "react";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

import { useQuery } from "@apollo/client";

import { loader } from "graphql.macro";

import NodeIcon from "./node-icon";

import L from "leaflet";

L.Icon.Default.imagePath =
  "//cdnjs.cloudflare.com/ajax/libs/leaflet/1.6.0/images/";

const MapItems = loader("../graphql/MapNode.graphql");

interface Props {
  node: any;
}

export function NodeMapList(props: Props) {
  // const { match } = props;
  const { node } = props;

  const { data, error, loading } = useQuery(MapItems, {
    variables: { nodes: `${node.id}` },
  });
  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    console.error(error.message);
    return <div>Error! {error.message}</div>;
  }
  // console.log("Map list: ", data);

  return (
    <List dense style={{ overflow: "auto", height: "100%" }}>
      {data &&
        data.mapItems &&
        data.mapItems[0] &&
        data.mapItems[0].values &&
        data.mapItems[0].values.map((item: any, index: number) => (
          <ListItem key={index}>
            <ListItemIcon>
              <NodeIcon subClass={item.subClass} __typename={"TagNode"} />
              {/* <img
                src={`http://demo.adcon.at/${item.iconURL}`}
                alt=""
                width="20"
                height="20"
              /> */}
            </ListItemIcon>
            <ListItemText primary={item.formattedValue} />
          </ListItem>
        ))}
    </List>
  );
}
